<template>
  <empty-component text="暂无预售订单信息"></empty-component>
</template>

<script>
import EmptyComponent from './EmptyComponent.vue'

export default {
  name: 'PreOrder',
  components: {
    EmptyComponent
  }
}
</script>
